import { TblBidDataDisplay } from "../../models/BidDataDisplay";
import {
  AddCurrentBidData,
  RemoveCurrentBidData,
} from "../actions/currentBidData.actions";
import { State, Selector, Action, StateContext } from "@ngxs/store";

export class CurrentBidDataStateModel {
  currentBidData: TblBidDataDisplay;
}

@State<CurrentBidDataStateModel>({
  name: "currentBidData",
  defaults: {
    currentBidData: undefined,
  },
})
export class CurrentBidDataState {
  @Selector()
  static getCurrentBidData(state: CurrentBidDataStateModel) {
    return state.currentBidData;
  }

  @Action(AddCurrentBidData)
  add(
    { patchState }: StateContext<CurrentBidDataStateModel>,
    { payload }: AddCurrentBidData
  ) {
    patchState({ currentBidData: payload });
  }
  @Action(RemoveCurrentBidData)
  remove({ patchState }: StateContext<CurrentBidDataStateModel>): void {
    patchState({ currentBidData: undefined });
  }
}
